import { actionAdmin } from '@/components/pages/ActionAdmin/ActionAdmin.i18n.en'
import { clients } from '@/components/pages/Client/Clients.i18n.en'
import { config } from '@/components/pages/ConfigTimeWork/Config.i18n.en'
import { incident } from '@/components/pages/Incidents/Incident.i18n.en'

import { admins } from './Admin/Admin.i18n.en'
import { announcements } from './Announcements/Announcements.i18n.en'
import { attendance } from './Attendance/Attendance.i18n.en'
import { attendanceEmployee } from './AttendanceEmployee/AttendanceEmployee.i18n.en'
import { attendanceLogs } from './AttendanceLogs/AttendanceLogs.i18n.en'
import { clientDevice } from './ClientDevice/ClientDevice.i18n.en'
import { customers } from './Customer/Customers.i18n.en'
import { detergentHistories } from './DetergentHistories/DetergentHistories.i18n.en'
import { detergents } from './Detergents/Detergents.i18n.en'
import { employees } from './Employees/Employees.i18n.en'
import { home } from './Home/Home.i18n.en'
import { idCards } from './IdCards/IdCards.i18n.en'
import { languages } from './Languages/Languages.i18n.en'
import { login } from './Login/Login.i18n.en'
import { machineParts } from './MachineParts/MachineParts.i18n.en'
import { machines } from './Machines/Machines.i18n.en'
import { notifications } from './Notifications/Notifications.i18n.en'
import { operators } from './Operator/Operators.i18n.en'
import { tankHistories } from './TankHistories/TankHistories.i18n.en'
import { tanks } from './Tanks/Tanks.i18n.en'
import { terminals } from './Terminals/Terminals.i18n.en'
import { uniforms } from './Uniforms/Uniforms.i18n.en'
import { washingCount } from './WashingCount/WashingCount.i18n.en'
import { washingHistory } from './WashingHistory/WashingHistory.i18n.en'
import { washingMachinePart } from './WashingMachinePart/WashingMachinePart.i18n.en'
import { washingMethods } from './WashingMethods/WashingMethods.i18n.en'

export const pages = {
  announcements,
  attendanceLogs,
  employees,
  idCards,
  languages,
  terminals,
  uniforms,
  login,
  admins,
  home,
  clientDevice,
  attendanceEmployee,
  attendance,
  config,
  clients,
  incident,
  actionAdmin,
  operators,
  customers,
  machines,
  machineParts,
  detergents,
  detergentHistories,
  washingMethods,
  washingCount,
  notifications,
  washingHistory,
  washingMachinePart,
  tanks,
  tankHistories,
}
